






































import {
  Cadastros,
  TotalAssinantes,
} from "@/services/dashboard.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { Component, Mixins, PropSync } from "vue-property-decorator";
import QuantidadeAtendentes from "./components/atendimentos/QuantidadeAtendentes.vue";
import FunilDeVendas from "./components/atendimentos/FunilDeVendas.vue";
import AtendimentosDoDiaTable from "./components/atendimentos/AtendimentosDoDiaTable.vue";

@Component({
  components: {
    QuantidadeAtendentes, FunilDeVendas, AtendimentosDoDiaTable,
  },
})
export default class DashboardTvAtendimentos extends Mixins(GlobalMixin) {
  loading = false;
  show = true;
  cadastros: Cadastros[] | null = null;

  loadingAssinantes = false;
  totalAssinantes: TotalAssinantes[] | null = null;

  @PropSync("date") dateSync!: string | null;

  mounted() {
    this.show = true;
    if (!this.dateSync) {
      this.dateSync = dayjs().format("YYYY-MM-DDT00:00:00");
    } else {
      const newDate = dayjs(this.dateSync).format("YYYY-MM-DDT00:00:00");
      this.dateSync = newDate;
    }
    dayjs.locale("pt-br");
  }
}

